import { render, staticRenderFns } from "./AddExtendedProfileQuestionRow.vue?vue&type=template&id=2fa1a401&"
import script from "./AddExtendedProfileQuestionRow.vue?vue&type=script&lang=js&"
export * from "./AddExtendedProfileQuestionRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports